module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1276-retro-min.79dc0381.jpg";